module.exports = __webpack_public_path__ + "img/_5.7939be2a.png";